export const SITE_URL = "https://broxconstruct.ro";

export const NAV_LINKS = [
  { label: "ACASĂ", to: "/" },
  { label: "SERVICII", to: "/servicii" },
  { label: "CUM FUNCȚIONEAZĂ", to: "/cum-functioneaza" },
  { label: "PROIECTE", to: "/proiecte" },
  { label: "DESPRE NOI", to: "/despre-noi" },
  { label: "PARTENERI", to: "/parteneri" },
  { label: "CONTACT", to: "/contact" },
];

export const WORK_TYPES = [
  "Renovare",
  "Construcție",
  "Instalație electrică",
  "Instalație sanitară",
  "Încălzire / centrală",
  "Acoperiș",
  "Fațadă",
  "Panouri fotovoltaice",
  "Amenajare exterioară",
  "Demolare / excavare",
  "Altă lucrare",
];

export const AREA_OPTIONS = ["Sub 50 mp", "50 – 100 mp", "100 – 200 mp", "Peste 200 mp", "Nu știu / nu e relevant"];

export const MATERIAL_OPTIONS = ["Doar manoperă", "Manoperă + materiale", "Nu știu / vreau recomandare"];

export const REQUEST_TYPES = [
  { id: "PROJECT", label: "PROIECT / LUCRARE" },
  { id: "SMALL_JOB", label: "LUCRARE MICĂ / REPARAȚIE" },
  { id: "URGENT", label: "INTERVENȚIE URGENTĂ" },
  { id: "B2B_MAINTENANCE", label: "MENTENANȚĂ PENTRU FIRMĂ" },
];

export const LEAD_TYPE_LABELS = {
  PROJECT: "Proiect",
  SMALL_JOB: "Lucrare mică",
  URGENT: "URGENT",
  B2B_MAINTENANCE: "B2B mentenanță",
};

export const PROJECT_CATEGORIES = [
  "Construcții",
  "Renovări",
  "Instalații",
  "Încălzire",
  "Acoperișuri",
  "Fațade",
  "Șeminee & Sobe",
  "Amenajări exterioare",
  "Energie",
  "Lucrări speciale",
  "Alte lucrări",
];

export const COMPANY = {
  brand: "BROX CONSTRUCT",
  legal: "Brox Consulting S.R.L.",
  website: "broxconstruct.ro",
  address: "Zone active: Arad, Timiș și Hunedoara",
};

export function waDisplay(num) {
  const digits = (num || "").replace(/[^0-9]/g, "");
  if (digits.length === 11 && digits.startsWith("40")) {
    const local = "0" + digits.slice(2);
    return `${local.slice(0, 4)} ${local.slice(4, 7)} ${local.slice(7)}`;
  }
  return num || "";
}

export const TIMELINE_OPTIONS = ["Cât mai curând", "În 1–3 luni", "În 3–6 luni", "Încă nu știu"];

export const LEAD_STATUSES = [
  "NEW", "CONTACTED", "SITE_VISIT", "QUOTED", "ACCEPTED", "ASSIGNED", "IN_PROGRESS", "COMPLETED", "LOST",
];

export const LEAD_STATUS_LABELS = {
  NEW: "Nou",
  CONTACTED: "Contactat",
  SITE_VISIT: "Vizită teren",
  QUOTED: "Ofertă trimisă",
  ACCEPTED: "Acceptat",
  ASSIGNED: "Atribuit",
  IN_PROGRESS: "În lucru",
  COMPLETED: "Finalizat",
  LOST: "Pierdut",
};

export const APP_STATUSES = ["NEW", "CONTACTED", "APPROVED", "REJECTED", "ARCHIVED"];

export const APP_STATUS_LABELS = {
  NEW: "Nou",
  CONTACTED: "Contactat",
  APPROVED: "Aprobat",
  REJECTED: "Respins",
  ARCHIVED: "Arhivat",
};

export const FALLBACK_SERVICES = [
  {
    slug: "constructii",
    title: "CONSTRUCȚII",
    tagline: "De la fundație la clădire finitată.",
    hero_image: "https://images.unsplash.com/photo-1549791084-5f78368b208b?auto=format&fit=crop&q=85&w=1600",
    items: ["Case la roșu", "Case la cheie", "Fundații", "Zidărie", "Beton", "Anexe", "Hale", "Extinderi"],
    intro: "Construim case, anexe, hale și extinderi cu echipe coordonate de un singur punct de contact.",
    description: "",
    seo_title: "", seo_description: "", order: 1, published: true,
  },
  {
    slug: "renovari-interioare",
    title: "RENOVĂRI & INTERIOARE",
    tagline: "Renovăm spațiul tău, cap-coadă.",
    hero_image: "https://images.unsplash.com/photo-1638885930125-85350348d266?auto=format&fit=crop&q=85&w=1600",
    items: ["Renovări complete", "Gresie", "Faianță", "Glet", "Zugrăveli", "Rigips", "Parchet", "Tavane", "Finisaje"],
    intro: "Renovări complete și finisaje interioare executate de echipe specializate.",
    description: "", seo_title: "", seo_description: "", order: 2, published: true,
  },
  {
    slug: "instalatii",
    title: "INSTALAȚII",
    tagline: "Instalații electrice, sanitare și termice pentru proiecte noi și renovări.",
    hero_image: "https://images.unsplash.com/photo-1667491295131-c6ccecd35f65?auto=format&fit=crop&q=85&w=1600",
    items: ["Instalații electrice", "Instalații sanitare", "Instalații termice", "Centrale termice", "Încălzire în pardoseală", "Sobe de teracotă", "Șeminee", "Aer condiționat / climatizare", "Modernizarea sistemelor de încălzire"],
    intro: "Instalații electrice, sanitare și termice executate de instalatori autorizați.",
    description: "", seo_title: "", seo_description: "", order: 3, published: true,
  },
  {
    slug: "exterior",
    title: "EXTERIOR",
    tagline: "Protejăm și finisăm clădirea, dincolo de pereți.",
    hero_image: "https://images.unsplash.com/photo-1614595737683-1740e41bfaac?auto=format&fit=crop&q=85&w=1600",
    items: ["Acoperișuri", "Fațade", "Termoizolații", "Pavaje", "Terase", "Amenajări curți", "Garduri", "Porți metalice", "Grătare zidite", "Bucătării exterioare"],
    intro: "Acoperișuri, fațade, termoizolații și amenajări exterioare.",
    description: "", seo_title: "", seo_description: "", order: 4, published: true,
  },
  {
    slug: "energie",
    title: "ENERGIE",
    tagline: "Soluții moderne pentru eficiența energetică a clădirii tale.",
    hero_image: "https://images.pexels.com/photos/35143437/pexels-photo-35143437.jpeg?auto=format&fit=crop&q=85&w=1600",
    items: ["Panouri fotovoltaice", "Pompe de căldură de ultimă generație", "Soluții eficiente energetic", "Modernizarea sistemelor de încălzire"],
    intro: "Fotovoltaice, pompe de căldură și eficiență energetică, integrate în proiect.",
    description: "", seo_title: "", seo_description: "", order: 5, published: true,
  },
  {
    slug: "lucrari-speciale",
    title: "LUCRĂRI SPECIALE",
    tagline: "Lucrările dificile, rezolvate cu utilajele potrivite.",
    hero_image: "https://images.unsplash.com/photo-1719411606465-5143b163b608?auto=format&fit=crop&q=85&w=1600",
    items: ["Demolări", "Excavări", "Săpături", "Transport moloz", "Transport pământ", "Lucrări cu utilaje"],
    intro: "Demolări, excavări, săpături și transport, organizate cap-coadă.",
    description: "", seo_title: "", seo_description: "", order: 6, published: true,
  },
  {
    slug: "interventii-mentenanta",
    title: "INTERVENȚII & MENTENANȚĂ",
    tagline: "Omul potrivit pentru problema ta.",
    hero_image: "https://images.unsplash.com/photo-1676311396794-f14881e9daaa?auto=format&fit=crop&q=85&w=1600",
    items: ["Reparații sanitare", "Reparații electrice minore", "Montaj și fixare", "Uși și mobilier", "Silicon și etanșări", "Reglaje și remedieri", "Mentenanță periodică"],
    intro: "Contactezi Brox Construct pentru reparații mici și mentenanță, fără să mai cauți meseriașul potrivit.",
    description: "", seo_title: "", seo_description: "", order: 7, published: true,
  },
];

export const HOW_IT_WORKS = [
  {
    nr: "01",
    title: "Spune-ne ce ai nevoie",
    text: "Pornești cererea direct din WhatsApp și ne descrii proiectul.",
  },
  {
    nr: "02",
    title: "Analizăm proiectul",
    text: "Stabilim detaliile și, dacă este necesar, programăm o vizită.",
  },
  {
    nr: "03",
    title: "Stabilim soluția",
    text: "Identificăm echipa, serviciile și materialele necesare proiectului.",
  },
  {
    nr: "04",
    title: "Executăm și coordonăm",
    text: "Lucrarea este executată de echipa potrivită, în funcție de specificul proiectului.",
  },
  {
    nr: "05",
    title: "Recepția lucrării",
    text: "Verificăm rezultatul și finalizăm proiectul.",
  },
];

export const HERO_IMAGES = {
  background: "https://images.unsplash.com/photo-1691425700573-5e2e6e4f6157?auto=format&fit=crop&q=85&w=1920",
  about: "https://images.unsplash.com/photo-1579847188804-ecba0e2ea330?auto=format&fit=crop&q=85&w=1600",
  materials: "https://images.unsplash.com/photo-1523413307857-ef24c53571ae?auto=format&fit=crop&q=85&w=1600",
  partners: "https://images.unsplash.com/photo-1562423130-8947ff8cdf59?auto=format&fit=crop&q=85&w=1600",
  blueprint: "https://images.unsplash.com/photo-1772442198624-4fc4d7281e89?auto=format&fit=crop&q=85&w=1600",
};

export function imgSrc(url) {
  if (!url) return "";
  if (url.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
